import { IconArrowRight as TablerIconArrowRight } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconArrowRight = /*#__PURE__*/ createOutlineIcon(
  TablerIconArrowRight,
  'IconArrowRight',
);
